import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure to import Bootstrap CSS

// Import the actual images as in the original code
import avatarImg from '../../assets/images/avatar/img-5.jpg';
import backgroundImg from '../../assets/images/realImages/nightlights.png';

const TestimonialSlider = () => {
  const testimonials = [
    {
      id: 1,
      text: "We 2 persons stayed at shriram homestay for 2 nights while visit to ayodhya darshan review property is good, newly built, and clean and ideal for family travellees and senior citizen close to the bypass highway for travellers by bus from lucknow cons 1. Property is at a distance from ram janmabhoomi temple 6 km however share auto available even at night 2. Decent restaurant Shri Ram International Home Stay panchsheel at a distance of 2 km 3. Nee t to have home delivery of food at the property 4. Property board to be displayed on main road for identification 5. Inside bathroom geyser to have in all bathrooms.",
      name: "Nitin Shah",
    },
    {
      id: 2,
      text: "The place was situated 4. 5 km from the railway station but it was at a very peaceful location. The caretaker was very humble and nice. He was connected with me even at night as i had to check in at 3:30 am. Also by mistake i booked for 8th of june and i had to stay on 7th june still the u happily allowed it as they had room available(they could refuse also as it was a mistake on my part and money was also paid in advance but still they allowed this is what the real honesty is and i liked it very much) i really thank the owner and caretaker to take care of everything and even my extended stay for 2 hours.",
      name: "Naman Sharma",
    },
    {
      id: 3,
      text: "The place is well located in ayodhya and is equally distant from the two points from most of the tourist places. On one side you can find places around ram mandir and on the other you can find places around guptar ghat. You can find auto and e-rickshaws from nearby. Basic amenities such as sugar, coffee etc with gas stove are also available. The owners are really very helpful and are always ready to walk the extra mile to support in anyway possible. I strongly recommend this place in case you are planning to visit ayodhya with family and are seeking multiple rooms.",
      name: "Rahul Sharma",
    },
  ];

  return (
    <div className="bg-image py-5" style={{backgroundImage: `url(${backgroundImg})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <Carousel
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={5000}
              renderIndicator={(onClickHandler, isSelected, index, label) => {
                return (
                  <button
                    className={`btn btn-sm mx-1 rounded-circle ${isSelected ? 'btn-light' : 'btn-outline-light'}`}
                    onClick={onClickHandler}
                    onKeyDown={onClickHandler}
                    key={index}
                    title={`${label} ${index + 1}`}
                    style={{ width: '10px', height: '10px', padding: 0 }}
                  />
                );
              }}
            >
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="text-center px-4">
                  <div className="d-flex flex-column align-items-center">
                    <p className="lead mb-4 fst-italic text-white mb-4">"{testimonial.text}"</p>
                    <p className="fw-bold text-white mb-4">{testimonial.name}</p>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;